import client from './client';

export interface UserListParams {
  page?: number;
  limit?: number;
  status?: string;
  search?: string;
  sort?: string;
  order?: string;
  active_since?: string;
  inactive_since?: string;
  created_after?: string;
  created_before?: string;
}

export const usersApi = {
  list: (params: UserListParams = {}) =>
    client.get('/api/admin/analytics/users/list', { params }),

  getDetail: (id: string) =>
    client.get(`/api/admin/users/${id}`),

  update: (id: string, data: Record<string, any>) =>
    client.put(`/api/admin/users/${id}`, data),

  delete: (id: string) =>
    client.delete(`/api/admin/users/${id}`),

  bulkDelete: (user_ids: string[]) =>
    client.post('/api/admin/users/bulk-delete', { user_ids }),

  getSegments: () =>
    client.get('/api/admin/users/segments'),
};
